import axios from 'axios'

export default  {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    create({commit}, rawItemMetaForm) {
      return new Promise((resolve, reject) => {
        axios
          .post('/supply-chains/raw-meta-datas', rawItemMetaForm)
          .then(res => {
            resolve(res.data.data.rawItem)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    update({commit}, rawItemMetaForm) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/supply-chains/raw-meta-datas/${rawItemMetaForm.id}`, rawItemMetaForm)
          .then(res => {
            resolve(res.data.data.rawItem)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    delete({commit}, {rawItemMetaId, rawItemId}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/supply-chains/raw-meta-datas/${rawItemMetaId}`, {
            params: {
              raw_item_id: rawItemId,
            },
          })
          .then(res => {
            resolve(res.data.data.rawItem)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    restore({commit}, {rawItemMetaId, rawItemId}) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/supply-chains/raw-meta-datas/${rawItemMetaId}/restore`, {
            raw_item_id: rawItemId,
          })
          .then(res => {
            resolve(res.data.data.rawItem)
          })
          .catch(error => {
            reject(error)
          })
      })
    },


    getSizes({commit}, rawItemId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/supply-chains/raw-items/${rawItemId}/sizes`)
          .then(res => {
            resolve(res.data.data.datas)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getSizeData({commit}, sizeId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/supply-chains/raw-meta-datas/sizes/${sizeId}/data`)
          .then(res => {
            resolve(res.data.data.size)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getMetaDataByMetaKey({commit}, rawItem) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/supply-chains/raw-meta-datas/getMetaData/${rawItem.rawItemId}/MetaKey/${rawItem.MetaKey}`)
          .then(res => {
            resolve(res.data.data.meta)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getMetaKeyLists({commit}) {
      return new Promise((resolve, reject) => {
        axios
          .get('/supply-chains/raw-meta-datas/meta-type/list')
          .then(res => {
            resolve(res.data.data.datas)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
